import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B">
        <path
          d="M55.8,35.3h5.8v31.4H57V43.5l0.3,1.4l-4.8,17.2h-3.6l-4.8-16.8l0.3-1.8v23.1h-4.7V35.3h5.9l5.1,19.1L55.8,35.3z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M50,5L11,27v45l39,23l39-22V28L50,5z"
      />
    </g>
  </svg>
);

export default IconLoader;
